export const ADD_REMINDER = 'ADD_REMINDER';
export const DEL_REMINDER = 'DEL_REMINDER';
export const CLEAR_ALL_REMINDER = 'CLEAR_ALL_REMINDER';

export const RECORD_LAP = 'RECORD_LAP';
export const DEL_LAP = 'DEL_LAP';
export const CLEAR_ALL_LAP= 'CLEAR_ALL_LAP';

export const SIGNED_IN = 'SIGNED_IN';
export const SIGNED_OUT = 'SIGNED_OUT';

//export const SUBMIT_IDEA = 'SUBMIT_IDEA';
export const UPDATE_IDEA = 'UPDATE_IDEA';
export const DEL_IDEA = 'DEL_IDEA';
export const GET_IDEA = 'GET_IDEA';



// WEBPACK FOOTER //
// ./src/constants/index.js